export default [
  {
    name: "standardAirport",
    path: "./textures/standard_airport.jpg"
  },
  {
    name: "hybridAirport",
    path: "./textures/hybrid_airport.jpg"
  },
  {
    name: "hybridRunway",
    path: "./textures/hybrid_runway.png"
  },
  {
    name: "hybridTaxi",
    path: "./textures/hybrid_taxi.png"
  },
  {
    name: "growthAirport",
    path: "./textures/growth_airport.jpg"
  },
  {
    name: "growthRunway",
    path: "./textures/growth_runway.png"
  },
  {
    name: "growthTaxi",
    path: "./textures/growth_taxi.png"
  },
  {
    name: "towerInterior",
    path: "./textures/tower_interior.jpg"
  },
  {
    name: "cameraCoverage",
    path: "./textures/growth_cameras_coverage.png"
  },
  {
    name: "airplaneTurn",
    path: "./textures/airplaneTurn.png"
  },
  {
    name: "airplaneTurnShadow",
    path: "./textures/airplaneTurnShadow.png"
  },
  {
    name: "towTurn",
    path: "./textures/towTurn.png"
  },
  {
    name: "towTurnShadow",
    path: "./textures/towTurnShadow.png"
  },
  {
    name: "carTurn",
    path: "./textures/carTurn.png"
  },
  {
    name: "carTurnShadow",
    path: "./textures/carTurnShadow.png"
  },
  {
    name: "fuelEngineTurn",
    path: "./textures/fuelEngineTurn.png"
  },
  {
    name: "fuelEngineTurnShadow",
    path: "./textures/fuelEngineTurnShadow.png"
  }
]